import React, { useState } from 'react';

import LinkIcon from '@icons/link';
import FacebookIcon from '@icons/facebook';
import LinkedinIcon from '@icons/linkedin';
import TwitterIcon from '@icons/twitter';
import IconButton from '@components/icon-button';
import { copyToClipboard } from '@utils/clipboard';
import { utmUrl, logShare } from '@utils/social';

import styles from './share-bar.module.scss';

const ShareBar = ({ className, link, facebook, twitter, linkedin }) => {
    const [copyText, setCopyText] = useState('Copy link');

    const copy = () => {
        const shareUrl = link || window.location.href;
        if (typeof Window != 'undefined') {
            setCopyText('Link Copied');
            copyToClipboard(utmUrl(shareUrl, 'clipboard', false));
            logShare('Clipboard', shareUrl);
        }
    };

    const onPress = (share) =>
        typeof share == 'object'
            ? { link: share.link, onClick: () => logShare(share.link, share.platform) }
            : {
                  onClick: () => {
                      const { link, platform } = share();
                      logShare(platform, link);
                      return link;
                  },
              };

    return (
        <div className={[styles.shareBar, className].join(' ')}>
            {facebook ? (
                <IconButton
                    tabIndex={0}
                    aria-label="Share to Facebook"
                    className={styles.shareBarButton}
                    {...onPress(facebook)}
                    icon={FacebookIcon}
                    target="_blank"
                />
            ) : null}
            {twitter ? (
                <IconButton
                    tabIndex={0}
                    aria-label="Share to Twitter"
                    className={styles.shareBarButton}
                    {...onPress(twitter)}
                    icon={TwitterIcon}
                    target="_blank"
                />
            ) : null}
            {linkedin ? (
                <IconButton
                    tabIndex={0}
                    aria-label="Share to LinkedIn"
                    className={styles.shareBarButton}
                    {...onPress(linkedin)}
                    icon={LinkedinIcon}
                    target="_blank"
                />
            ) : null}

            <IconButton
                tabIndex={0}
                aria-label="Click to copy url of this story"
                className={styles.shareBarCopyButton}
                onClick={copy}
                icon={LinkIcon}
                label={copyText}
            />
        </div>
    );
};

export default ShareBar;
